var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckGreen = function SvgCheckGreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14017_30445)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23Z",
    fill: "#059669"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6155 8.47014C17.9061 8.86644 17.8412 9.40009 17.5728 9.81184C15.4065 13.1358 13.7797 15.299 12.7643 16.5622C12.0993 17.3897 10.915 17.4513 10.159 16.7061C9.22668 15.7871 7.92368 14.4215 6.57468 12.7497C6.21793 12.3076 6.14418 11.687 6.49293 11.2386C6.76593 10.8876 7.07373 10.5831 7.35723 10.3364C7.88158 9.88024 8.64983 9.98229 9.12313 10.4912C10.4872 11.9581 11.3077 12.9782 11.3077 12.9782C11.3077 12.9782 12.6721 10.9584 14.8636 7.84684C15.2225 7.33724 15.869 7.09934 16.4085 7.41144C16.8059 7.64139 17.2579 7.98239 17.6155 8.47014Z",
    fill: "#F8FAFC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14017_30445"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#fff"
  })))));
};
export default SvgCheckGreen;